import { useEffect } from 'react';
import { useLocation, Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { CheckCircle, Package2 } from 'lucide-react';
import { Button } from '@/components/ui/button';

export function OrderCompletePage() {
  const location = useLocation();
  const { orderId, trackingId } = location.state || {};

  useEffect(() => {
    if (!orderId) {
      window.location.href = '/';
    }
  }, [orderId]);

  return (
    <>
      <Helmet>
        <title>Order Complete - Store</title>
        <meta name="description" content="Your order has been successfully placed" />
      </Helmet>

      <div className="min-h-screen bg-gray-100 dark:bg-gray-900 py-12">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white dark:bg-gray-800 rounded-lg shadow-lg p-8">
            <div className="text-center">
              <CheckCircle className="mx-auto h-16 w-16 text-green-500" />
              <h1 className="mt-4 text-3xl font-bold text-gray-900 dark:text-white">
                Order Complete!
              </h1>
              <p className="mt-2 text-lg text-gray-600 dark:text-gray-400">
                Thank you for your purchase
              </p>
            </div>

            <div className="mt-8">
              <div className="border-t border-gray-200 dark:border-gray-700 pt-8">
                <dl className="divide-y divide-gray-200 dark:divide-gray-700">
                  <div className="py-4 flex justify-between">
                    <dt className="text-sm font-medium text-gray -700 dark:text-gray-300">Order ID</dt>
                    <dd className="text-sm font-bold text-gray-900 dark:text-white">{orderId}</dd>
                  </div>
                  <div className="py-4 flex justify-between">
                    <dt className="text-sm font-medium text-gray-700 dark:text-gray-300">Tracking ID</dt>
                    <dd className="text-sm font-bold text-gray-900 dark:text-white">{trackingId}</dd>
                  </div>
                </dl>
              </div>
            </div>

            <div className="mt-8 space-y-4">
              <Link to={`/track?id=${trackingId}`}>
                <Button className="w-full flex items-center justify-center gap-2">
                  <Package2 className="h-5 w-5" />
                  Track Order
                </Button>
              </Link>
              
              <Link to="/">
                <Button variant="outline" className="w-full">
                  Continue Shopping
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}